// The free trial's picker (course_trials/new): count the ticks against the
// cap and stop one past it, so a student never submits four lines to be
// told three. The page works without this: the form posts and CourseTrial
// refuses a pick past the cap in a sentence of its own.
//
// The cap is the form's data-max (CourseTrial::LINES) and both sentences are
// templates on the summary, so nothing here types copy or a figure. A box
// the server disabled (a line with no questions) is never touched.

function setup() {
  const form = document.querySelector("[data-trial-picker]");
  if (!form) return;

  const max = Number(form.dataset.max);
  const summary = form.querySelector("[data-trial-count]");
  const boxes = Array.from(form.querySelectorAll("input[name='objectives[]']")).filter((box) => !box.disabled);
  const fill = (template, values) => template.replace(/%\{(\w+)\}/g, (_, key) => String(values[key]));

  const sync = () => {
    const picked = boxes.filter((box) => box.checked).length;
    const full = picked >= max;
    boxes.forEach((box) => {
      if (!box.checked) box.disabled = full;
      box.closest("li")?.classList.toggle("is-capped", full && !box.checked);
    });
    if (summary && picked > 0) {
      summary.textContent = fill(full ? summary.dataset.full : summary.dataset.template, { picked, max });
    }
  };

  // A pick past the cap that arrived pre-ticked (a link can carry more than
  // the cap): keep the first `max`, as the server's pre-tick does.
  boxes.filter((box) => box.checked).slice(max).forEach((box) => { box.checked = false; });

  boxes.forEach((box) => box.addEventListener("change", sync));
  sync();
}

// The guard every module in this pack carries — see mock_request_wizard.js.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setup);
} else {
  setup();
}
